import { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getCurrentUser } from "@/api/agent";

export default function AdminGuard() {
  const [loading, setLoading] = useState(true);
  const [access, setAccess] = useState<"granted" | "agent" | "login">("login");

  useEffect(() => {
    getCurrentUser()
      .then((user) => {
        if (user.frontflag === true) {
          // frontflag=true 是代理商，跳转到资料库
          setAccess("agent");
        } else {
          // frontflag=false 是管理员，允许访问
          setAccess("granted");
        }
      })
      .catch(() => {
        // 未登录
        setAccess("login");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
      </div>
    );
  }

  if (access === "login") {
    return <Navigate to="/login" replace />;
  }

  if (access === "agent") {
    return <Navigate to="/library" replace />;
  }

  return <Outlet />;
}
